<template>
  <div>
    <template v-for="(item, index) in data">
      <!-- 因为有子集和无子集渲染html标签不一样，所以要分为两种情况-->
      <!--情况一：有子集的情况：                         -->
      <el-submenu
        :index="item.name"
        :key="item.id"
        v-if="item.children.length > 0"
      >
        <template slot="title">
          <i :class="item.icon"></i>
          <span>{{ item.title }}</span>
        </template>
        <myitem :data="item.children"></myitem>
      </el-submenu>

      <!-- 情况二：没子集的情况： -->
      <router-link :to="item.path">
        <el-menu-item :index="item.name" @click="selectMenu(item)">
          <template slot="title">
            <i :class="item.icon"></i>
            <span slot="title">{{item.title}}</span>
          </template>
        </el-menu-item>
      </router-link>

<!--      <router-link v-else :to="item.path">-->
<!--        <el-menu-item :key="item.id" @click="selectMenu(item)">-->
<!--          <i :class="item.icon"></i>-->
<!--          <span slot="title">{{ item.title }}</span>-->
<!--        </el-menu-item>-->
<!--      </router-link>-->
    </template>
  </div>
</template>

<script>
  export default {
    name: "myitem",
    props: {
      data: {
        type: Array,
        default: [],
      },
    },
    methods: {
      selectMenu(item) {
        this.$store.commit("addTab", item)
      }
    }
  };
</script>
